import React, { Component } from "react";
import { Redirect, useLocation } from 'react-router-dom';

import Form from "react-validation/build/form";
import Input from "react-validation/build/input";
import CheckButton from "react-validation/build/button";

import { connect } from "react-redux";
import { login } from "../../actions/auth";
import CommonServices from "../../services/common.service";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const required = (value) => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        This field is required!
      </div>
    );
  }
};

class Login extends Component {
  constructor(props) {
    super(props);
    this.handleLoginClick = this.handleLoginClick.bind(this);
    this.handleLogin = this.handleLogin.bind(this);
    this.onChangeUsername = this.onChangeUsername.bind(this);
    this.onChangePassword = this.onChangePassword.bind(this);

    let u = new URLSearchParams(this.props.location.search).get("u");
    let p = new URLSearchParams(this.props.location.search).get("p");
    let kiosk = u&&u.length>0;

    if (!u){
      u = "";
    }
    if (!p){
      p = "";
    }

    this.state = {
      username: u,
      password: p,
      loading: false,
      kiosk: kiosk
    };
  }

  onChangeUsername(e) {
    this.setState({
      username: e.target.value,
    });
  }

  onChangePassword(e) {
    this.setState({
      password: e.target.value,
    });
  }

  handleLoginClick(e) {
    e.preventDefault();
    this.handleLogin();
  }
  handleLogin(){
    this.setState({
      loading: true,
    });

    if (!this.state.kiosk){
      this.form.validateAll();
    }

    const { dispatch, history } = this.props;

    if (this.state.kiosk || this.checkBtn.context._errors.length === 0) {
      dispatch(login(this.state.username, this.state.password,
        this.state.kiosk))
        .then(() => {
          history.push("/planner");
          //window.location.reload();
        })
        .catch(() => {
          this.setState({
            loading: false
          });
        });
    } else {
      this.setState({
        loading: false,
      });
    }
  }

  componentDidMount() {
    if (this.state.kiosk){
      this.handleLogin();
    }
  }

  render() {
    const { isLoggedIn, message } = this.props;
    const urlError = new URLSearchParams(this.props.location.search).get('error');

    if (isLoggedIn) {
      return <Redirect to="/planner" />;
    }

    return (
      <div className="col-md-12" style={{padding:5}}>
        <div className="card card-container">
          <h2>Login</h2>
          <Form
            onSubmit={this.handleLoginClick}
            ref={(c) => {
              this.form = c;
            }}
          >
            <div className="form-group">
              <label htmlFor="username">Username</label>
              <Input
                type="text"
                className="form-control"
                name="username"
                value={this.state.username}
                onChange={this.onChangeUsername}
                validations={[required]}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <Input
                type="password"
                className="form-control"
                name="password"
                value={this.state.password}
                onChange={this.onChangePassword}
                validations={[required]}
              />
            </div>

            <div className="form-group">
              <button
                className="btn btn-primary btn-block"
                disabled={this.state.loading}
              >
                {this.state.loading && (
                  <span className="spinner-border spinner-border-sm"></span>
                )}
                <span>Login</span>
              </button>
            </div>

            {(message || urlError) && (
              <div className="form-group">
                <div className="alert alert-danger" role="alert">
                  {urlError ? `Authentik login failed: ${urlError.replace(/_/g, ' ')}` : message}
                </div>
              </div>
            )}
            <CheckButton
              style={{ display: "none" }}
              ref={(c) => {
                this.checkBtn = c;
              }}
            />
          </Form>

          {!this.state.kiosk && (
            <>
              <hr />
              <a
                href={CommonServices.getApiUrl() + "auth/authentik/start"}
                className="btn btn-secondary btn-block"
              >
                Login with Authentik
              </a>
            </>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { isLoggedIn } = state.auth;
  const { message } = state.message;
  return {
    isLoggedIn,
    message
  };
}

export default connect(mapStateToProps)(Login);
